import {
  AccordionSummary as MUIAccordionSummary,
  AccordionSummaryProps as MUIAccordionSummaryProps,
} from '@mui/material';
import { CaretIcon } from '../../../../icons';
import { mergeSX } from '../../../../services/helpers';
import { AB3 } from '../../../../theme';

export interface IAccordionSummaryProps extends MUIAccordionSummaryProps {}

const buildSX = () => ({
  '& .MuiAccordionSummary-content': {
    margin: '8px 0',
    '&.Mui-expanded': {
      margin: '8px 0',
    },
  },
  '&.MuiAccordionSummary-root.Mui-expanded': {
    minHeight: 48,
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    color: AB3,
  },
});

const AccordionSummary = (props: IAccordionSummaryProps) => {
  const { sx, children, ...restProps } = props;

  return (
    <MUIAccordionSummary
      sx={mergeSX(buildSX(), sx)}
      expandIcon={<CaretIcon />}
      {...restProps}
    >
      {children}
    </MUIAccordionSummary>
  );
};

export default AccordionSummary;
